import { AxiosPromise, AxiosRequestConfig } from "axios";
import { apis } from "service";

const BASE_URL = 'https://xxl6-bbr3-kxzs.m2.xano.io/api:'

const PRODUCT_LIST = BASE_URL + 'FiAQK2sE/product_list_forex_v3'
const FOREX_ORDER_REFUND = BASE_URL + 'FiAQK2sE/refund_forex_order_v3'

export type RateAndMargin = {
    l1_commission: number;
    l2_commission: number;
    l3_commission: number;
    l2_id: number;
    ibr_rate: number;
}

export type ProductDetail = {
    id: number;
    name: string;
    subCategory: string;
}

export type Product = {
    id: string;
    product_id: number;
    quantity: number;
    inr_amount: number;
    status: string;
    rate_and_margins: RateAndMargin[];
    product_detail: ProductDetail;
    country_currency_want: string;
    country_currency_have:string
}

export type ProductList = {
    id: number;
    product: Product[];
}

export type RefundPayload = {
    product_id: string[];
    refund_reason: string;
    refund_amount: number;
    refund_transfer: string;
    txn_id: string;
    order_id: number;
    mode: string;
}

export const getProductList = async (order_id: number): Promise<ProductList> => {
    const payload: AxiosRequestConfig = {
        params: {
            order_id
        }
    }
    const response = await apis.get(PRODUCT_LIST, payload)
    return response.data
}

export const refundForexOrder = async (data: RefundPayload): Promise<any> => {
    const payload: AxiosRequestConfig<RefundPayload> = {
        data: data
    }
    return await apis.post(FOREX_ORDER_REFUND, payload)
}